"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateFns = require("date-fns");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dateWrapper: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'bold',
      marginTop: "".concat(theme.spacing(2), "px !important"),
      marginBottom: "".concat(theme.spacing(6), "px !important"),
      lineHeight: 'normal'
    }
  };
});
var FFCertificatesDateEditConfig = {
  emptyLabel: 'FF Certificates Date',
  isEmpty: function isEmpty(props) {
    return !(props !== null && props !== void 0 && props.currDate);
  }
};
var FFCertificatesDate = function FFCertificatesDate(_ref) {
  var currDate = _ref.currDate;
  var classes = useStyles();
  if (!currDate) return null;
  var dateFormat = 'MMM d, yyyy';
  var formattedCurrDate = (0, _dateFns.format)(new Date(), dateFormat);
  return __jsx("p", {
    className: classes.dateWrapper
  }, formattedCurrDate);
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/ffcertificatesdate')(FFCertificatesDate, FFCertificatesDateEditConfig);
exports.default = _default;